module.exports = __webpack_public_path__ + "fonts/avenir/ea64e82f-5215-4e26-a15f-a6739e1c1020.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/ea64e82f-5215-4e26-a15f-a6739e1c1020.ttf
// module id = 45
// module chunks = 0